import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

//renderizar a aplicação React na raiz do documento HTML
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
